import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter
} from 'react-router-dom'

import ProtectedRoute from '@components/ProtectedRoute'
import ExpertRoutes from '@root/Expert'
import ProjectRoutes from '@root/Project'
import ClientContactSearchPage from '@root/ClientContact/ClientContactSearchPage'
import ContactPage from '@root/ClientContact/ClientContactPage'
import ContractPage from './Contract/ContractPage'
import Header from './components/Header/Header.js'
import Navbar from './components/Navbar/Navbar.js'
import MobileNavbar from './components/Navbar/MobileNavbar'
import IconsPreview from '@components/IconsPreview'
import './App.sass'
import './animation.sass'
import './components/Details/Details.sass'
import './components/Icon/Icon.sass'
import '../node_modules/rc-tooltip/assets/bootstrap.css'
import './components/Tooltip/Tooltip.sass'
import Modal from './components/Modal'
import Spinner from './components/spinner'
import GrowlWrapper from '@components/Growl'
import Sidebar from '@components/Sidebar'
import MyProjects from '@root/MyProjects'
import ClientProjects from '@root/ClientProjects'
import DashboardPage from './Dashboard/DashboardPage'
import ProjectsPipeline from './Reports/ProjectsPipeline'
import { CreatedInvoices, DraftedInvoices } from './Reports/Invoices'
import PerformanceReport from './Reports/Performances'
import RevenuesReport from './Reports/Revenues'
import StandardConditions from '@components/standardConditions/standardConditions.js'
import NotFoundPage from '@components/NotFound/NotFoundPage'
import GeneralFees from '@root/Reports/GeneralFees'
import FinancialRevenue from './Reports/FinancialRevenue'
import PaymentsReport from './Reports/Payments'
import LogPage from '@root/Log/LogPage.js'
import Message from '@root/Message'
import ClientRecordsRoutes from './ClientRecords'
import ContractSearchPage from '@root/Contract/ContractSearchPage'
import Employee from './Employee'
import EmployeeSearch from './EmployeeSearch'
import EmailTemplates from './EmailTemplates'
import AtheneumOfficePage from '@root/Admin/AtheneumOfficePage'
import CompliancePage from '@root/Admin/CompliancePage'
import ContractualDetailsPage from '@root/Admin/ContractualDetailsPage'
import DepartmentResponsibleUsersPage from '@root/Admin/DepartmentResponsibleUsersPage'
import EpdRejectionReasonPage from '@root/Admin/EpdRejectionReasonPage'
import UnitOfWorkPage from './Admin/UnitOfWork'
import BookingStopPage from '@root/Admin/BookingStopPage'
import { AnnounceDeploymentPage } from '@root/Admin/AnnounceDeploymentPage'
import PropTypes from 'prop-types'
import CurrencyRates from './Reports/CurrencyRates'
import ProfilePage from '@root/Profile'
import { Settings } from '@root/Settings'
import { NotificationList } from '@root/NotificationList'
import {
  ForgotPassword,
  ForgotPasswordSuccess,
  Login,
  LoggedOut,
  ResetPassword,
  ResetPasswordSuccess,
  QuickLogin
} from '@root/Auth'
import { handleUrlRedirect } from '@atheneum/api/dist/lib'
import { initStores } from './stores'
import Team from '@root/Team'
import TagManager from 'react-gtm-module'
import ExpertPayments from '@root/Reports/ExpertPayments'
import ElasticReindex from '@root/Admin/ElasticReindex'
import ProjectManagement from '@root/ProjectManagement'
import ContactsMissingLinkedinUrl from '@root/ClientRecords/ContactsMissingLinkedinUrl'
import ComplianceBreach from '@root/ComplianceBreach'
import { MassProcessing, MassProcessingList } from '@root/MassProcessing'

import AppContainer from './AppContainer.js'
import ExpertCompliance from '@root/Expert/ExpertCompliance'
import ExpertUnsubscribe from '@root/Expert/ExpertUnsubscribe'
import ExpertInterest from '@root/Expert/ExpertInterest'
import AnonymousAction from '@root/AnonymousAction'
import 'ag-grid-enterprise'
import ZoomStreamPage from '@root/ZoomStreamPage'
import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE)

class App extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    userStore: PropTypes.object
  }

  constructor(props) {
    super(props)

    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID
    })
  }

  setAnonymousActionRoute = (path, AnonymousAction, NotFoundPage) => {
    if (process.env.REACT_APP_ANONACTION_ACTIVE === '1') {
      return <Route path={path} component={AnonymousAction} />
    }

    return (
      <Route path={path}>
        <NotFoundPage title="Page disabled" />
      </Route>
    )
  }

  render() {
    const { userStore, staticData } = this.props

    if (staticData.loading) return <Spinner />

    return (
      <Router>
        <AppContainer>
          <div>
            <GrowlWrapper />
            <Switch>
              <Route path={`/logged-out`} component={LoggedOut} />
              <Route
                path={`/expert/compliance/:language`}
                component={ExpertCompliance}
              />
              <Route path={`/expert/compliance`} component={ExpertCompliance} />
              <Route path={`/expert/compliance`} component={ExpertCompliance} />
              {this.setAnonymousActionRoute(
                '/anonymous-action',
                AnonymousAction,
                NotFoundPage
              )}
              <Route path={`/expert/compliance`} component={ExpertCompliance} />
              {this.setAnonymousActionRoute(
                '/anonymous-action',
                AnonymousAction,
                NotFoundPage
              )}
              <Route path={`/unsubscribe/:hash/:actionid?`} component={ExpertUnsubscribe} />
              <Route path={`/unsubscribe`} component={ExpertUnsubscribe} />
              <Route path={`/expert/interest/:interested/:actionId`} component={ExpertInterest} />
              <Route path={`/zoom-recording/:uuid`} component={ZoomStreamPage} />
              <Route
                path="/auth"
                render={({ location }) => (
                  <AuthRoutes location={location} userStore={userStore} />
                )}
              />
              <Route
                render={({ location }) => {
                  return (
                    <AuthNeededRoutes
                      staticData={staticData}
                      location={location}
                      userStore={userStore}
                    />
                  )
                }}
              />
            </Switch>
          </div>
        </AppContainer>
      </Router>
    )
  }
}

const authBaseUrl = '/auth'
const AuthRoutes = observer(({ location, userStore }) => {
  if (userStore.user) {
    return handleUrlRedirect(location)
  } else {
    return (
      <Switch>
        <Route exact path={`${authBaseUrl}/login`} component={Login} />
        <Route
          exact
          path={`${authBaseUrl}/forgot-password`}
          component={ForgotPassword}
        />
        <Route
          exact
          path={`${authBaseUrl}/forgot-password-success`}
          component={ForgotPasswordSuccess}
        />
        <Route
          exact
          path={`${authBaseUrl}/reset-password/:token`}
          component={ResetPassword}
        />
        <Route
          exact
          path={`${authBaseUrl}/set-password/:token`}
          render={() => <ResetPassword setPassword />}
        />
        <Route
          exact
          path={`${authBaseUrl}/reset-password-success`}
          component={ResetPasswordSuccess}
        />
        <Route
          exact
          path={`${authBaseUrl}/quick-login`}
          component={QuickLogin}
        />
        <Route render={() => <Redirect to={`${authBaseUrl}/login`} />} />
      </Switch>
    )
  }
})

const AuthNeededRoutes = withRouter(observer(
  class AuthNeededRoutes extends Component {
    static propTypes = {
      staticData: PropTypes.object,
      location: PropTypes.object,
      userStore: PropTypes.object
    }

    constructor(props) {
      super(props)

      extendObservable(this, {
        isInitialized: false
      })
    }

    async componentDidMount() {
      if (!this.isInitialized) {
        await initStores(this.props.history)
        this.isInitialized = true
      }
    }

    render() {
      const { staticData, location, userStore } = this.props
      const { user } = userStore
      const { USER_TYPES } = staticData.CONST
      if (window.location.pathname === 'logged-out') return
      if (!user && !userStore.loading) {
        const query =
          location.pathname === '/' ? '' : `?redirect=${location.pathname}`
        return <Redirect to={`/auth/login${query}`} />
      } else if (!user && userStore.loading) {
        return <Spinner />
      } else if (user.userTypeId === USER_TYPES.CLIENT) {
        window.location = `/legacy/#/app/dashboard`
      } else {
        if (!this.isInitialized) return <Spinner />
        return (
          <div
            className={
              location.pathname === '/dashboard' ||
                location.pathname.includes('correspondence') ||
                location.pathname.includes('list')
                ? 'App'
                : 'App--old'
            }>
            <Sidebar />
            <Header />
            {location.pathname === '/dashboard' ||
              location.pathname.includes('correspondence') ||
              location.pathname.includes('list') ? (
              <>
                <div className="desktop-navbar">
                  <Navbar />
                </div>
                <div className="mobile-navbar">
                  <MobileNavbar />
                </div>
              </>
            ) : (
              <Navbar />
            )}
            <Modal />
            <div>
              <Route
                path="/"
                exact
                render={() => <Redirect to="/dashboard" />}
              />
              <Route path="/dashboard" component={DashboardPage} />
              <Switch>
                <Route
                  path="/client-search/parent-account/:id/contracts/:id"
                  component={ContractPage}
                />
                <ClientRecordsRoutes />
              </Switch>
              <Route path="/expert*" component={ExpertRoutes} />
              <Route
                path="/client-contact-search"
                component={ClientContactSearchPage}
              />
              <Route path="/project*" component={ProjectRoutes} />
              <Route path="/client-contact/:id" component={ContactPage} />
              <Route path="/my-projects" component={MyProjects} />
              <Route path="/reports/revenues" component={RevenuesReport} />
              <ProtectedRoute
                roles={[
                  'FeeManagement',
                  'Accounting',
                  'AdvancedExpertManagement',
                  'ProjectManagement',
                  'AdvancedReporting',
                  'Admin'
                ]}
                path="/contract-search"
                component={ContractSearchPage}
              />
              <ProtectedRoute
                roles={[
                  'FeeManagement',
                  'Accounting',
                  'AdvancedExpertManagement',
                  'ProjectManagement',
                  'AdvancedReporting',
                  'Admin'
                ]}
                path="/contract/:id"
                component={ContractPage}
              />
              <Route path="/reports/currency-rates" component={CurrencyRates} />
              <ProtectedRoute
                roles={[
                  'FeeManagement',
                  'Accounting',
                  'AdvancedExpertManagement',
                  'AdvancedReporting',
                  'Admin'
                ]}
                path="/reports/expert-payments"
                component={ExpertPayments}
              />
              <Route
                path="/reports/projects-pipeline"
                component={ProjectsPipeline}
              />
              <Route
                path="/reports/created-invoices"
                component={CreatedInvoices}
              />
              <Route
                path="/reports/drafted-invoices"
                component={DraftedInvoices}
              />
              <Route path="/employee/:id" component={Employee} />

              <ProtectedRoute
                roles={['Accounting', 'Admin', 'TeamManagment', 'HR']}
                path="/employee-search"
                component={EmployeeSearch}
              />
              <ProtectedRoute
                roles={['Admin', 'OPSManagment', 'AdvancedExpertManagement']}
                path="/compliance-breach"
                component={ComplianceBreach}
              />
              <Route
                path="/reports/performance"
                component={PerformanceReport}
              />
              <Route path="/reports/general-fees" component={GeneralFees} />
              <ProtectedRoute
                roles={['Accounting', 'Admin']}
                path="/reports/financial-revenue"
                component={FinancialRevenue}
              />
              <ProtectedRoute
                roles={['Accounting', 'Admin']}
                path="/reports/payments"
                component={PaymentsReport}
              />
              <Route
                path="/standard-conditions"
                component={StandardConditions}
              />
              <Route path="/log" component={LogPage} />
              <ProtectedRoute
                roles={['Admin']}
                path="/admin/email-templates"
                component={EmailTemplates}
              />
              <ProtectedRoute
                roles={['Admin', 'OPSManagment']}
                path="/admin/atheneum-office"
                component={AtheneumOfficePage}
              />
              <ProtectedRoute
                roles={['Admin']}
                path="/admin/compliance"
                component={CompliancePage}
              />
              <ProtectedRoute
                roles={['Admin', 'OPSManagment']}
                path="/admin/contractual-details"
                component={ContractualDetailsPage}
              />
              <ProtectedRoute
                roles={['Admin']}
                path="/admin/department-responsible-users"
                component={DepartmentResponsibleUsersPage}
              />
              <ProtectedRoute
                roles={['Admin']}
                path="/admin/epd-rejection-reason"
                component={EpdRejectionReasonPage}
              />
              <ProtectedRoute
                roles={['Admin', 'OPSManagment']}
                path="/admin/units-of-work"
                component={UnitOfWorkPage}
              />
              <ProtectedRoute
                roles={['Admin', 'TeamManagment']}
                path="/admin/teams"
                component={Team}
              />
              <ProtectedRoute
                roles={['Admin', 'Accounting']}
                path="/admin/booking-stop"
                component={BookingStopPage}
              />
              <ProtectedRoute
                roles={['Admin']}
                path="/admin/deployment-announcement"
                component={AnnounceDeploymentPage}
              />
              <ProtectedRoute
                roles={['Admin']}
                path="/admin/elastic-reindex"
                component={ElasticReindex}
              />
              <Route
                path="/project-management"
                component={ProjectManagement}
                exact
              />
              <Route
                path="/project-management/:id"
                exact
                component={ProjectManagement}
              />
              <Route path="/client-projects" component={ClientProjects} exact />
              <Route path="/client-projects/:clientName" component={ClientProjects} exact />
              <Route path="/profile" component={ProfilePage} />
              <Route path="/settings" component={Settings} />
              <Route path="/notification-list" component={NotificationList} />
              <Route
                path="/contacts-missing-linkedin-url"
                component={ContactsMissingLinkedinUrl}
              />
              <Route
                path="/outlook-authorization-complete"
                render={() => (
                  <Message message="You've successfuly linked your Outlook account to the app!" />
                )}
              />
              <Route path="/list" exact component={MassProcessing} />
              <Route path="/list/:id" component={MassProcessingList} exact />
              {devRoutes()}
              <iframe
                title="download-frame"
                className="download-frame"
                id="download-iframe"
              />
            </div>
          </div>
        )
      }
    }
  }
))

const devRoutes = () => {
  if (process.env.NODE_ENV !== 'development') return null

  // Register development only routes here
  const routes = [<Route key="/icons" path="/icons" component={IconsPreview} />]

  return routes
}

export default inject('staticData', 'userStore')(observer(App))
